<template>
  <section class="section-intro">
    <div class="content-intro bg-white p-t-40 p-b-70">
      <div class="container">
        <a
          class="weatherwidget-io"
          href="https://forecast7.com/zh-tw/25d13121d74/keelung-city/"
          data-label_1="基隆市"
          data-label_2="一週天氣概況"
          data-font="微軟正黑體 (Microsoft JhengHei)"
          data-icons="Climacons Animated"
          data-theme="orange"
        >基隆市 一週天氣概況</a>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-4 p-t-30">
            <div class="blo1">
              <div class="wrap-pic-blo1 bo-rad-10 hov-img-zoom">
                <a href="https://reurl.cc/V07En" target="_blank">
                  <img src="/static/images/intro-01.jpg" alt="IMG-INTRO">
                </a>
              </div>
              <div class="wrap-text-blo1 p-t-35">
                <a href="https://reurl.cc/V07En" target="_blank">
                  <h4 class="txt5 color0-hov trans-0-4 m-b-13">兒童節</h4>
                </a>
                <p class="m-b-20">再2天，基隆童話藝術節就正式登場了喔4/4~4/7!!! 今天海洋廣場的恐龍都已先就定位了~帶大家搶先看!</p>
                <a href="https://reurl.cc/V07En" class="txt4" target="_blank">
                  看更多
                  <i class="fa fa-long-arrow-right m-l-10" aria-hidden="true"></i>
                </a>
              </div>
            </div>
          </div>
          <div class="col-md-4 p-t-30">
            <div class="blo1">
              <div class="wrap-pic-blo1 bo-rad-10 hov-img-zoom">
                <a href="https://goo.gl/dhZBNf" target="_blank">
                  <img src="/static/images/intro-02.jpg" alt="IMG-INTRO">
                </a>
              </div>
              <div class="wrap-text-blo1 p-t-35">
                <a href="https://goo.gl/dhZBNf" target="_blank">
                  <h4 class="txt5 color0-hov trans-0-4 m-b-13">清明返鄉</h4>
                </a>
                <p class="m-b-20">返鄉掃墓交通資訊看這邊！！！</p>
                <a href="https://goo.gl/dhZBNf" class="txt4" target="_blank">
                  看更多
                  <i class="fa fa-long-arrow-right m-l-10" aria-hidden="true"></i>
                </a>
              </div>
            </div>
          </div>
          <div class="col-md-4 p-t-30">
            <div class="blo1">
              <div class="wrap-pic-blo1 bo-rad-10 hov-img-zoom">
                <a href="https://goo.gl/jhZBNE" target="_blank">
                  <img src="/static/images/intro-04.jpg" alt="IMG-INTRO">
                </a>
              </div>
              <div class="wrap-text-blo1 p-t-35">
                <a href="https://goo.gl/jhZBNE" target="_blank">
                  <h4 class="txt5 color0-hov trans-0-4 m-b-13">春日小島聚</h4>
                </a>
                <p class="m-b-20">今年的兒童節連假真的有夠精彩！！除了微笑港灣有2019基隆童話藝術節～「和平島公園」因應兒童節連假，也有很棒的活動喔～</p>
                <a href="https://goo.gl/jhZBNE" class="txt4" target="_blank">
                  看更多
                  <i class="fa fa-long-arrow-right m-l-10" aria-hidden="true"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.content-intro a{
  text-decoration:none;
}
</style>
<script >
!(function (d, s, id) {
  let js,
    fjs = d.getElementsByTagName(s)[0]
  if (!d.getElementById(id)) {
    js = d.createElement(s)
    js.id = id
    js.src = 'https://weatherwidget.io/js/widget.min.js'
    fjs.parentNode.insertBefore(js, fjs)
  }
})(document, 'script', 'weatherwidget-io-js')
export default {
  name: 'Intro'
}
</script>



// WEBPACK FOOTER //
// src/components/Intro.vue